<div class="container" *ngIf="showFallbackUi">
  <div class="row">
    <div class="col-md-12 logo d-flex justify-content-center">
      <img
        src="/assets/images/shared/logo.png"
        style="height:auto;margin-bottom:10px;width:50%;"
        alt="ShareMe"
      />
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 text-center">
      <button type="button" class="btn btn-primary" (click)="openApp()">
        Отвори в приложението
      </button>

      <button type="button" class="btn btn-link" (click)="copyLink()">
        Копирай линка
      </button>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12 d-sm-flex justify-content-center">
      <a
        class="d-flex justify-content-center"
        [href]="playStoreUrl"
        target="_blank"
        rel="noopener"
      >
        <img class="app-image" src="assets/images/redirect/google-play.svg" alt="Google Play" />
      </a>

      <span class="mr-1"></span>

      <a
        class="d-flex justify-content-center"
        [href]="appStoreUrl"
        target="_blank"
        rel="noopener"
      >
        <img class="app-image" src="assets/images/redirect/app-store.svg" alt="App Store" />
      </a>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-12 text-center">
      <p class="hint">
        Ако не се отвори, във Facebook натисни <b>⋯</b> (горе вдясно) и избери <b>Open in browser</b>.
      </p>
    </div>
  </div>
</div>

<div class="container text-center" *ngIf="!showFallbackUi">
  <img
    src="/assets/images/shared/logo.png"
    style="height:auto;margin-bottom:10px;width:50%;"
    alt="ShareMe"
  />

  <p class="hint">Отваряме в приложението…</p>

  <button type="button" class="btn btn-link" (click)="openStore()">
    Ако не се отвори → към магазина
  </button>
</div>
